import { render } from "./indexPage.vue?vue&type=template&id=6b89e89c"
import script from "./indexPage.vue?vue&type=script&lang=js"
export * from "./indexPage.vue?vue&type=script&lang=js"
script.render = render

export default script